import Api from 'src/api/Base'

class GetSpaces extends Api {
  requestUrl = `/api/space`
}

export default GetSpaces
